import { createContext, useContext, useEffect } from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import { ConfirmModalBridge } from '../components/ConfirmModalBridge';
import { antdThemeConfig } from '../styles/tokens';

// The OMS has one theme: light. Dark mode was removed on purpose.
type ThemeMode = 'light';

interface ThemeContextValue {
  theme: ThemeMode;
}

const ThemeContext = createContext<ThemeContextValue>({ theme: 'light' });

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
    try {
      localStorage.removeItem('theme');
    } catch {
      // Nothing stored when storage is unavailable.
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: 'light' }}>
      <ConfigProvider theme={antdThemeConfig()}>
        <AntdApp>
          <ConfirmModalBridge />
          {children}
        </AntdApp>
      </ConfigProvider>
    </ThemeContext.Provider>
  );
}
